import React from 'react';
import { useOfferContext } from '../../../context';
import { SimilarLink } from '../../../components/SimilarLink';

export function IdenticalOffersLinkContainer() {
  const {
    offer: { identicalOffers },
    tracking: { trackShowAllIdenticalOffers },
  } = useOfferContext();

  const handleClick = React.useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>): void => {
      e.stopPropagation();
      trackShowAllIdenticalOffers();
    },
    [trackShowAllIdenticalOffers],
  );

  if (!identicalOffers) {
    return null;
  }

  return (
    <SimilarLink
      text="Посмотреть копии объявления от других продавцов"
      url={identicalOffers.url}
      onClick={handleClick}
    />
  );
}
